export interface IQualification {
    identifier: string;
    system: string;
    code: string;
    period: string;
    issuer: string;
    tenantId: number;
    language: string;
}